import React, { useState, useEffect, useCallback } from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import { bounce_right_to_left_variants } from "shared/components/animations";
import banner from "assets/images/gah/winner-modal-banner.png";

const WinnerModal = ({ card, onNextRound }) => {
  const [counter, setCounter] = useState(10);

  useEffect(() => {
    let timer;
    timer =
      counter > 0 && setInterval(() => setCounter((prev) => prev - 1), 1000);
    counter === 0 && onNextRound();
    return () => clearInterval(timer);
  }, [counter]);

  const handleNextRound = useCallback(
    _.debounce(() => onNextRound(), 500, {
      leading: true,
      trailing: false
    }),
    []
  );

  return (
    <div className="winner-modal-container">
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={bounce_right_to_left_variants}
        className="winner-modal-inner"
      >
        <div className="border-div" />
        <img alt="" src={banner} className="banner-logo" />

        <div className="modal-card-wrapper">
          <div className="title-div">
            <h2>{card.text}</h2>
          </div>

          <div className="gif-div">
            <img alt="" src={card.gif_url} />
          </div>
        </div>

        <div className="next-palyer" onClick={handleNextRound}>
          <div className="button-border-div" />
          <h2>{`NEXT PLAYER (${counter})`}</h2>
        </div>
      </motion.div>
    </div>
  );
};

export default WinnerModal;
